<template>
  <div>
    <div
      v-if="preloader"
      class="d-flex align-center justify-center flex-column"
      style="height: 100vh"
    >
      <template>
        <bubble-loader />
      </template>
    </div>
    <div v-else>
      <div class="custom-container pt-6">
        <v-card
          height="64px"
          width="100%"
          class="background mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
          style="
            position: fixed;
            z-index: 200;
            top: 0;
            width: 98%;
            padding-top: 16px;
          "
        >
          <v-card-title class="ml-0 pl-0">
            <p class="breadcrumb-text">Dashboard</p>
            <span
              ><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span
            >
          </v-card-title>
          <UserNavMenu />
        </v-card>
        <v-row align="stretch" class="px-4">
          <v-col cols="12" sm="6" md="8" class="d-flex flex-column">
            <h3 class="ml-4">Mixpanel Dashboard</h3>
          </v-col>

          <v-col cols="12" sm="6" md="4" class="d-flex justify-end">
            <v-btn
              @click="filterDialog = true"
              dense
              rounded
              class="btn outline-btn elevation-0 mx-2"
              ><v-icon class="pr-2">mdi-tune</v-icon>
              <span v-if="filterCount > 0">Filter ({{ filterCount }})</span>
              <span v-else>Filter</span>
            </v-btn>
          </v-col>
        </v-row>
      <v-row>
  <!-- LEFT COLUMN: Full-height Large Chart -->
  <v-col cols="12" md="8">
    <v-card class="pa-4 d-flex flex-column ml-4" elevation="2" style="height: 100%">
      <span class="chart-title"> Candidate Lifecycle Funnel</span>
      <div style="font-size: 12px">Track candidate progress across stages</div>
      <MixpanelBarChart
        :chart-data="{
          labels: engagementData.labels,
          datasets: [
            {
              label: 'No. Of Candidates',
              backgroundColor: '#AC9EE4',
              data: engagementData.datasets,
              percent: engagementData.dataPercent,
            },
          ],
        }"
        :enable-data-labels="true"
        :eventData="engagementData.datasets"
      />
    </v-card>
  </v-col>

  <!-- RIGHT COLUMN: Two stacked charts with 50% height each -->
  <v-col cols="12" md="4" class="d-flex flex-column">

    <!-- Chart 1 (Top 50%) -->
    <v-card class="pa-4 mb-4 d-flex flex-column" elevation="2" style="height: 50%">
      <span class="chart-title">Candidate Drop-off Rate </span>
      <div style="font-size: 12px">In Percent</div>
      <LineChart
        :labels="registeredLabel"
        :dataset-data="registeredData"
        :percent-data="registeredPercent"
      />
    </v-card>

    <!-- Chart 2 (Bottom 50%) -->
    <v-card class="pa-4 d-flex flex-column" elevation="2" style="height: 50%">
      <span class="chart-title"> Device & Browser Usage </span>
      <div style="font-size: 12px">Track browser and device preferences</div>
      <BarChart
        :chart-data="{
          labels: chartData.labels,
          datasets: chartData.datasets
        }"
        :enable-data-labels="true"
      />
    </v-card>

  </v-col>
</v-row>

      </div>
    </div>
    <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
      <v-card
        width="570px"
        height="100vh"
        class="filterDialogClass d-flex flex-column"
      >
        <v-row class="mt-4 mx-1">
          <v-col>
            <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
              Filter
            </div>
          </v-col>
          <v-col class="d-flex justify-end">
            <div @click="clearFilter" class="clear-filter-btn">
              Clear Filter
            </div>
          </v-col>
        </v-row>

        <v-tabs vertical>
          <div class="ml-3 mt-4 mr-4 filterLine">
            <v-tab class="black--text justify-start" active-class="activeTab">
              <div class="tab-content">
                <span>Date</span>
                <span v-if="selectedDateFilter" class="ml-1"
                  ><div class="status-count-badge">
                    <p>1</p>
                  </div></span
                >
              </div>
            </v-tab>
          </div>
          <v-tab-item>
            <v-card flat height="580px" class="d-flex flex-column">
              <v-card-text>
                <!-- <v-text-field
                  v-model="searchCampaignTerm"
                  label="Search Here..."
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  class="px-4"
                />
               -->
                <v-chip-group
                  v-model="selectedDateFilter"
                  column
                  active-class="active-chip"
                >
                  <v-chip
                    v-for="(item, index) in dateRange"
                    :key="index"
                    :value="item"
                    elevated
                  >
                    {{ item }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>

        <div class="filterDialogButton">
          <v-card-actions class="px-6 pb-3">
            <v-spacer></v-spacer>
            <v-btn
              rounded
              depressed
              class="btn outline-btn font-weight-medium pa-4"
              @click="filterDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn pa-4"
              @click="
                (filterDialog = false),
                  filterData(),
                
                  (isApply = true)
              "
              >Apply</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import DashboardController from "@/controllers/DashboardController";
import MixpanelBarChart from "@/components/MixpanelDashboard/MixpanelBarChart.vue";
import LineChart from "@/components/MixpanelDashboard/DropOffRate.vue";
import BarChart from "@/components/MixpanelDashboard/BarChart.vue"
import _ from "lodash";

export default {
  name: "AnalyticsDashboard",
  components: {
    BubbleLoader,
    UserNavMenu,
    BarChart,
    LineChart,
    MixpanelBarChart
  },

  data() {
    const today = new Date().toISOString().split("T")[0];
    return {
      // Last 30 days
      debouncedFetchData: null, 
      filterCount: 0,
      filterDialog: false,
      selectedDateFilter: "Today", // default selected chip
      selectedStartDate: today, // default = today
      selectedEndDate: today,
      registeredData: [],
      registeredPercent: [],
      chartData:[],
      registeredLabel: ["", "Registered", "Demo Submitted"],
      // dateRange: [new Date(Date.now() - 3 * 24 * 60 * 60 * 1000), new Date()],
      dateRange: [
        "Today",
        "Yesterday",
        "7 Days",
        "30 Days",
        "3 Months",
        "6 Months",
      ],
      preloader: true,
      eventData: { labels: [], datasets: [] },
      engagementData: {
        labels: [
        ],
        datasets: [],
      },

      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },

  async mounted() {
    this.computeDateRange(this.selectedDateFilter);
    
  },
  created() {
    // ✅ Assign debounced function
    this.debouncedFetchData = _.debounce(this.fetchData, 500);
     if (this.debouncedFetchData) {
      this.debouncedFetchData();
     }
  },
  watch: {
    selectedDateFilter(newValue) {
      this.computeDateRange(newValue);
    },
  },
  methods: {
    computeDateRange(filter) {
      const today = new Date();

      let startDate = new Date(today);
      let endDate = new Date(today);

      switch (filter) {
        case "Today":
          // already set to today
          break;

        case "Yesterday":
          startDate.setDate(today.getDate() - 1);
          endDate = new Date(startDate);
          break;

        case "7 Days":
          startDate.setDate(today.getDate() - 7);
          break;

        case "30 Days":
          startDate.setDate(today.getDate() - 30);
          break;

        case "3 Months":
          startDate.setMonth(today.getMonth() - 3);
          break;

        case "6 Months":
          startDate.setMonth(today.getMonth() - 6);
          break;
      }

      this.selectedStartDate = startDate.toISOString().split("T")[0];
      this.selectedEndDate = endDate.toISOString().split("T")[0];
    
      console.log("Start:", this.selectedStartDate);
      console.log("End:", this.selectedEndDate);
    },
    async fetchData(retryCount = 0) {
      this.preloader = true;
      try {
        const params = {
          from_date: this.selectedStartDate,
          to_date: this.selectedEndDate,
          env_url: process.env.VUE_APP_FRONTEND_DOMAIN
        };
        
        // Fetch raw events
        // const events = await DashboardController.getMixpanelData("events", {
        //   ...params,
        //   // event: ["LoginScreenLoaded", "EmailFilled"],
        // });
        // this.eventData = this.transformEventData(events);
        const response = await DashboardController.getMixpanelData("funnels", {
          ...params,
        });
      
        this.funnelData = response.data.funnelData;
        this.chartData = response.data.chartData;
        

        if (this.funnelData) {
        
          this.engagementData.labels = this.funnelData.map((funnel) => funnel.step);
          this.engagementData.datasets = this.funnelData.map(
            (step) => step.count
          );
          this.engagementData.dataPercent = this.computeStepPercentages(
            this.engagementData.datasets
          );

          this.registeredData = [
            
            this.engagementData.datasets[0], // first element
            this.engagementData.datasets[
              this.engagementData.datasets.length - 2
            ], // second-last
          ];

          this.registeredPercent = [
            0,
            ...this.computeStepPercentages(this.registeredData),
          ];
          this.registeredData = [0, ...this.registeredData];
          // this.registeredPercent = [0, ...this.registeredPercent.slice(1)];
          
        }

        this.preloader = false;
      } catch (error) {
        if (error.response && error.response.status === 429 && retryCount < 5) {
          console.warn("Mixpanel rate limit hit, retrying in 2 seconds...");
          setTimeout(() => this.fetchData(retryCount + 1), 2000); // retry after 2 sec
        } else {
          console.error("Failed to fetch analytics:", error);
          
        }
      }
    },
    computeStepPercentages(arr) {
      if (!arr.length) return [];

      const percentages = [100]; // first step always 100%

      for (let i = 1; i < arr.length; i++) {
        const prev = arr[i - 1];
        const curr = arr[i];

        if (prev === 0) {
          percentages.push(0); // avoid division by zero
        } else {
          percentages.push(Number(((curr / prev) * 100).toFixed(2)));
        }
      }

      return percentages;
    },

    /* ---------------- TRANSFORM EVENTS ---------------- */

  
    filterData() {
      this.debouncedFetchData()
    },
    getFilterCount() {},
    clearFilter() {
      this.selectedDateFilter = "Today";
      // this.getFilterCount();
      // this.debouncedFetchData()
    },
  },
};
</script>
